import {
  mainSuite
} from '../services/ServiceFactory';

export function useUserService() {
  return mainSuite.userService;
}

export default useUserService;
